var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H8.828A8.828 8.828 0 0 0 0 97.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V97.103a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4173cd",
    d: "M185.38 125.55H512v37.27H185.38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 162.82h512v37.27H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4173cd",
    d: "M185.38 200.09H512v37.27H185.38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 237.36h512v37.27H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4173cd",
    d: "M0 274.641h512v37.27H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 311.91h512v37.27H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4173cd",
    d: "M0 349.18h512v37.27H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M63.976 111.642l14.767 68.333 23.107-9.572z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M63.976 111.642l26.32 63.547-11.553 4.786z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M121.404 250.289l-14.768-68.333-23.107 9.572z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M121.404 250.289l-26.321-63.547 11.553-4.786z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M162.013 152.252l-68.332 14.767 9.571 23.107z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M162.013 152.252l-63.547 26.32-4.785-11.553z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M23.367 209.679l68.332-14.767-9.572-23.107z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M23.367 209.679l63.546-26.32 4.786 11.553z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M121.404 111.642l-37.875 58.761 23.107 9.572z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M121.404 111.642l-26.321 63.547-11.554-4.786z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M63.976 250.289l37.874-58.761-23.107-9.572z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M63.976 250.289l26.32-63.547 11.554 4.786z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M162.013 209.679l-58.761-37.874-9.571 23.107z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M162.013 209.679l-63.547-26.32 4.786-11.554z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M23.367 152.252l58.76 37.874 9.572-23.107z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M23.367 152.252l63.546 26.32-4.786 11.554z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M92.69 105.931l-12.506 68.781h25.011z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M92.69 105.931v68.781H80.184z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M92.69 256l12.505-68.781H80.184z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M92.69 256v-68.781h12.505z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M167.724 180.966L98.943 168.46v25.011z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M167.724 180.966H98.943V168.46z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M17.655 180.966l68.781 12.505V168.46z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M17.655 180.966h68.781v12.505z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M145.747 127.908l-57.479 39.793 17.686 17.686z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M145.747 127.908l-48.636 48.636-8.843-8.843z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M39.633 234.023l57.478-39.793-17.686-17.686z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M39.633 234.023l48.635-48.636 8.843 8.843z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M145.747 234.023l-39.793-57.479-17.686 17.686z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M145.747 234.023l-48.636-48.636 8.843-8.843z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M39.633 127.908l39.792 57.479 17.686-17.686z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd5a",
    d: "M39.633 127.908l48.635 48.636-8.843 8.843z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.69,
    cy: 180.97,
    r: 25.01,
    fill: "#ffe15a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.47238a1dd2bd86ad9af02dec13ddb236.svg";
export { ForwardRef as ReactComponent };